import React from 'react';
import PropTypes from 'prop-types';
import PlatformHeader from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Env = window.cccisd.env;
const Fortress = window.cccisd.fortress;

let wpUrl = Env.wpUrl || Appdefs.app.wpUrl || 'https://bhatrainings.health.maryland.gov';
if (wpUrl.endsWith('/')) {
    wpUrl = wpUrl.replace(/\/$/, '');
}

export const publicLinks = [
    { url: wpUrl, label: 'Home' },
    { url: '/onlinetraining', label: 'Online Training' },
    { url: wpUrl + '/events', label: 'Events' },
    { url: wpUrl + '/faqs', label: 'FAQs' },
];

function Header({ className, noLogoLink, noBorder }) {
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'primaryNav').nav;
    } catch (e) {
        // meh, leave it empty
    }

    primaryNavLinks = [...publicLinks, ...primaryNavLinks];

    if (Fortress.hasAccess('app.allCourseProgress') && !primaryNavLinks.some(n => n.url === '/all-progress')) {
        primaryNavLinks.push({ url: '/all-progress', label: 'All Course Progress' });
    }

    return (
        <PlatformHeader
            wrapperClassName={`${style.wrapper} ${noBorder ? style.noBorder : ''}`}
            containerClassName={className}
            logoClassName={style.logo}
            primaryNavLinks={primaryNavLinks}
            showAlertAction={false}
            showHomeAction={false}
            showAdminAction={Fortress.isSuperUser()}
            {...(noLogoLink ? { logoLink: null } : {})}
        />
    );
}

Header.propTypes = {
    className: PropTypes.string,
    noLogoLink: PropTypes.bool,
    noBorder: PropTypes.bool,
};

Header.defaultProps = {
    className: 'container',
    noLogoLink: false,
    noBorder: false,
};

export default Header;
